module.exports = __webpack_public_path__ + "static/media/ETC-BNB.9d3dfce0.svg";